const insightSteps= [
    {
      content: <h2>Let's begin !</h2>,
      locale: { skip: <strong>SKIP</strong> },
      placement: "center",
      target: "body"
    },
    {
      content: <h2>You can click on this area to access the content where you can view the maturity score and level. Additionally, you can also see the AI comment on the survey result.</h2>,
      placement: "right",
      target: "#leftMenuInsightSummary",
      title: "First step"
    },
    {
      content: <h2>You can click on this area to view your strengths and weaknesses based on the survey results.</h2>,
      placement: "right",
      target: "#leftMenuInsightSw",
      title: "Second step"
    },
    {
      content: <h2>Here, you can view the findings categorized by sections.</h2>,
      placement: "right",
      target: "#leftMenuInsightFindings",
      title: "Third step"
    },
    {
      content: <h2>Here, you can view the recommendations and roadmap details based on the report output.</h2>,
      placement: "right",
      target: "#leftMenuInsightRR",
      title: "Fourth step"
    },
    {
      content: <h2>Here, you can access the gap analysis of the report.</h2>,
      placement: "right",
      target: "#leftMenuInsightGap",
      title: "Fifth step"
    },
    {
      content: <h2>Here, you can access the comparison chart of the answers given to different questions based on the report results.</h2>,
      placement: "right",
      target: "#leftMenuInsightCompare",
      title: "Sixth step"
    },
    {
      content: <h2>You can check the heatmap report here to easily see which areas need more attention based on the results.</h2>,
      placement: "right",
      target: "#leftMenuInsightHeatmap",
      title: "Seventh step"
    },
    {
      content: <h2>You can view and download the final version of your report here</h2>,
      placement: "right",
      target: "#leftMenuInsightMainReport",
      title: "Eighth step"
    },
    {
      content: <h2>You can view the steps used in the maturity level assessment of your report here.</h2>,
      placement: "right",
      target: "#leftMenuInsightBD",
      title: "Ninth step"
    },  
  ]
  export default insightSteps;